<template>
<!--  <div style="background-color: #2F93b7" class="ss" :style="{'transform':`scale(${scalesNum}) translate(0%,0)`,
'-webkit-transform':`scale(${scalesNum}) translate(0%,0)`,
'-moz-transform':`scale(${scalesNum}) translate(0%,0)`,
'-o-transform':`scale(${scalesNum}) translate(0%,0)`,
'-ms-transform':`scale(${scalesNum}) translate(0%,0)`}">
  </div>-->
  <div>
    <div style="background-color: #2F93b7;">
      <div class="aa">
        <!-- <div style="text-align: left">
          <ul style="padding-left: 0px;padding-bottom: 20px">
            <span style="font-weight:bold;float: left;color: black">政府部门网站</span>
  </ul>
          <ul style="padding-left: 0px">
            <li v-for="(item, index) in gdwebList" v-if="index < 4" :key="index" @click="viewWebPartner(item.url)">
              <span style="padding-top: 13px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 250px;display: inline-block;font-size: 14px"><a :href="item.url" target="_blank">{{item.title}}</a></span>
            </li>
          </ul>
        </div> -->

        <div style="text-align: left;">
  <!--        <ul style="font-weight:bold;padding-left: 0px">联系我们</ul>-->
          <ul style="padding-left: 0px;">
            <span style="font-weight:bold;color: black">联系我们</span>
          </ul>
          <ul style="padding-left: 0px;line-height: 24px;">
            <li style="padding-top: 13px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;color: black">电话:{{mobile}}</li>
            <!-- <li style="padding-top: 13px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 240px;display: inline-block;font-size: 14px;color: black">手机:{{ name }}{{phone}}</li> -->
            <li style="padding-top: 13px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;color: black">E-mail:{{ mail }}</li>
            <li style="padding-top: 13px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;color: black">地址:{{ address }}</li>
          </ul>
        </div>
        <div style="text-align: left;display: flex; ">
  <!--        <ul style="font-weight:bold;padding-left: 0px">关注我们</ul>-->
          <ul style="padding-left: 0px;padding-bottom: 15px;margin-right: 40px;line-height: 30px;">
            <span style="font-weight:bold;float: left;color: black">关注我们</span>
            <li><img style="width: 80px;height: 80px" :src="imgurl"></li>
            <li style="font-size: 14px;color: black">扫一扫关注</li>
  <!--          <span style="margin-top: 2px;float: right;padding-right: 50px;font-size: 6px"><router-link to="/Contactus">更多>></router-link></span>
          --></ul>

          <ul style="padding-left: 0px;line-height: 38.5px;">
            <li style="font-size: 14px;color: black">河南省化工医药安全生产协会公众号</li>
            <li style="font-size: 14px;color: black"> 网址:{{ weburl }}</li>
            <li style="font-size: 14px;color: black">版权所有 @河南省化工医药安全生产协会</li>
            <li>
              <a href="https://beian.miit.gov.cn" style="font-size: 14px">豫ICP备2022021384号-1</a></li>
          </ul>
        </div>
        <!-- <div style="text-align: left">
          <ul style="padding-left: 0px;line-height: 38.5px;">
            <li style="font-size: 14px;color: black">河南省化工医药安全生产协会公众号</li>
            <li style="font-size: 14px;color: black">网址:{{ weburl }}</li>
            <li style="font-size: 14px;color: black">版权所有 @河南省化工医药安全生产协会</li>
            <li>
              <a href="https://beian.miit.gov.cn" style="font-size: 14px">豫ICP备2022021384号-1</a></li>
          </ul>
        </div> -->
      </div>
    </div>
    <!-- <div class="bq">版权所有 @河南省化工医药安全生产协会<a href="https://beian.miit.gov.cn" style="padding-left: 20px">豫ICP备2022021384号-1</a></div> -->
  </div>
</template>
<script>
export default {
  name: "Footer",
  data(){
    return{
      name:'',
      phone:'',
      mobile:'',
      mail:'',
      address:'',
      imgurl:'',
      weburl:'https://www.hnshgyyaqscxh.com',
      gdwebList:[
        {id:'1',title:'中华人民共和国应急管理部',url:'https://www.mem.gov.cn/'},
        {id:'2',title:'中国安全生产科学研究院',url:'https://www.chinasafety.ac.cn/'},
        /*{id:'3',title:'中华人民共和国安全管理部',url:'static/images/pingtai.png'},
        {id:'4',title:'中华人民共和国安全管理部',url:'static/images/pingtai.png'},*/
      ],
      rawebList:[
        {id:'1',title:'中国安全生产协会',url:'https://www.china-safety.org.cn/'},
        {id:'2',title:'中国化学品安全协会',url:'http://www.chemicalsafety.org.cn/'},
        {id:'3',title:'化学工业出版社有限公司',url:'http://www.cip.com.cn/'},
        {id:'4',title:'中国石油和化学工业联合会',url:'http://www.cpcif.org.cn/'},
      ],
    }
  },
  created() {
    /*this.gdweb();
    this.raweb();*/
    this.contact();
    // this.followus();
  },
  methods:{
    /*政府部门网站*/
    gdweb(){
      let params = {}
      this.axios.post('/api/index/gdwebList',params).then((response) => {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*相关协会网站*/
    raweb(){
      let params = {}
      this.axios.post('/api/index/rawebList',params).then((response) => {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*联系我们*/
    contact (){
      let params = {}
      this.axios.post('/api/index/contactList',params).then((response) => {
        console.log(response)
        if(response.data.msg == 'success'){
          this.name = response.data.data.phone_name
          this.mobile = response.data.data.zj
          this.phone = response.data.data.phone
          this.mail = response.data.data.email
          this.address = response.data.data.addr
          this.imgurl = response.data.data.qr_code
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*关注我们*/
    followus(){
      let params = {}
      this.axios.post('/api/index/followusList',params).then((response) => {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>
.router-link-active {
  text-decoration: none;
}
a{
  text-decoration: none;
  color: black;
}
.aa{
  width: 1200px;
  height: 210px;
  display: flex;
  margin: 0 auto;
}
.aa div{
  width: 50%;
  /* float: left; */
}
li { list-style: none }
.bq{
  width: 1000px;
  margin: 0px auto;
  float: left;
  padding-left: 23%;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue